import React from 'react'
import classes from './Card.module.css'
export default function Card({ children, className = '',...props }) {
  return (
    <div className={`${classes.card} ${className}`} {...props}>
    {children}
  </div>
  )
}
